import { type Statut, StatutLibelle } from '../shared/Statut'

// DR: adhérent uniquement
export type StatutAdherent = Extract<Statut, 'SaisieAdherent' | 'EnCoursDeTransmission'>

export const StatutAdherentLibelle: Record<StatutAdherent, string> = {
  SaisieAdherent: StatutLibelle.SaisieAdherent,
  EnCoursDeTransmission: StatutLibelle.EnCoursDeTransmission,
}
